/* eslint-disable react/jsx-fragments */
/* eslint-disable react/state-in-constructor */
import mixpanel from 'mixpanel-browser';
import PropTypes from 'prop-types';
import React from 'react';
import * as consts from '../../constants';
import { Textarea } from '../UI';
import Stars from './Stars';
import './style.css';

class Rating extends React.Component {
  state = {
    stars: 0,
    message: '',
    error: false,
    loading: false,
    sentForm: false,
  };

  handleChange = (e) => {
    this.setState({ message: e.target.value });
  };

  submitRating = async () => {
    const { stars, message } = this.state;
    const { email, appName } = this.props;
    if (stars === 0 || message.trim().length < 1) {
      this.setState({ error: true });
      return;
    }
    this.setState({ error: false, loading: true });

    const appKey = appName.replace('.', '').toLowerCase();
    const formData = {
      fields: [
        {
          name: 'email',
          value: email,
        },
        {
          name: 'rating',
          value: `${stars}`,
        },
        {
          name: 'feedback',
          value: message,
        },
        {
          name: 'application',
          value: appKey,
        },
      ],
    };

    // Setup for the API request
    const hubspotFormEndpoint = process.env.REACT_APP_HUBSPOT_URL;
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    };

    // Analytics
    mixpanel.track(consts.eventNames.sentRating, {
      stars,
      comment: message,
      app: appName,
    });

    fetch(hubspotFormEndpoint, requestOptions)
      .catch(() => {})
      .finally(() => {
        this.setState({ sentForm: true, loading: false });
      });
  };

  render() {
    const { message, stars, error, loading, sentForm } = this.state;
    const { appName } = this.props;

    if (sentForm) {
      return (
        <div className="rating-box">
          <div>
            <h4 className="rating-message">Thanks for using {appName} Cloud</h4>
            <p className="rating-message" style={{ fontSize: '24px', fontWeight: '400' }}>
              See you next time!
            </p>
          </div>
        </div>
      );
    }

    return (
      <div className="rating-box">
        { loading
          ? (
            <React.Fragment>
              <h4 className="rating-message">
                Sending feedback...
              </h4>
            </React.Fragment>
          )
          : (
            <React.Fragment>
              <h4 className="rating-message">
                Please rate the quality of
                <br />
                your {appName} Cloud experience...
              </h4>
            </React.Fragment>
          )}
        <Stars
          rating={stars}
          onRate={({ rating }) => this.setState({ stars: rating })}
        />
        <div className="rating-comment">
          <Textarea
            name="message"
            value={message}
            onChange={this.handleChange}
            rows={3}
          />
        </div>
        { !loading
        && (
        <div className="rating-button">
          <div
            className="error-message"
            style={{ visibility: error ? 'visible' : 'hidden' }}
          >
            Please include both a star rating<br /> and a comment
          </div>
          <button
            type="submit"
            onClick={this.submitRating}
          >
            Submit
          </button>
        </div>
        )}
      </div>
    );
  }
}

Rating.propTypes = {
  appName: PropTypes.string,
  email: PropTypes.string,
};

Rating.defaultProps = {
  appName: 'VU.CITY',
  email: '',
};

export default Rating;
